module.exports = __webpack_public_path__ + "static/media/q.c3923a59.png";